export const docList = [
  {
    docName: "Whistle Blower Policy-2025",
    fileName: "Whistle Blower Policy-2025.pdf",
    filePath: "files/Whistle Blower Policy-2025.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "DarkStore Holidays",
    fileName: "Dark Store - Holiday List - 2026.pdf",
    filePath: "files/Dark Store - Holiday List - 2026.pdf",
    author: "",
    docAuthor: "System Generated",
    date: "",
  },
  {
    docName: "DC CC RPC Holidays",
    fileName: "DC CC RPC - Holiday List - 2026.pdf",
    filePath: "files/DC CC RPC - Holiday List - 2026.pdf",
    author: "",
    docAuthor: "System Generated",
    date: "",
  },
  {
    docName: "HO & Circle Office Holidays",
    fileName: "HO & Cirlce - Holiday List - 2026.pdf",
    filePath: "files/HO & Cirlce - Holiday List - 2026.pdf",
    author: "",
    docAuthor: "System Generated",
    date: "",
  },
  {
    docName: "Store Holidays",
    fileName: "Stores - Holiday List - 2026.pdf",
    filePath: "files/Stores - Holiday List - 2026.pdf",
    author: "",
    docAuthor: "System Generated",
    date: "",
  },
  {
    docName: "IT Policy",
    fileName: "IT Policy.pdf",
    filePath: "files/IT Policy.pdf",
    author: "",
    docAuthor: "System Generated",
    date: "",
  },
  {
    docName: "Anti Bribery Anti Corruption Policy",
    fileName: "Anti Bribery Anti Corruption Policy.pdf",
    filePath: "files/Anti Bribery Anti Corruption Policy.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "Code of Conduct",
    fileName: "Code of Conduct.pdf",
    filePath: "files/Code of Conduct.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "More Jobs - IJP Policy",
    fileName: "More Jobs - IJP Policy.pdf",
    filePath: "files/More Jobs - IJP Policy.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "MRPL Frontend Leave Policy",
    fileName: "MRPL Frontend Leave Policy V2.pdf",
    filePath: "files/MRPL Frontend Leave Policy V2.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "MRPL Backend Leave Policy",
    fileName: "MRPL Backend Leave Policy.pdf",
    filePath: "files/MRPL Backend Leave Policy.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "MRPL Local Conveyance Policy",
    fileName: "MRPL Local Conveyance Policy.pdf",
    filePath: "files/MRPL Local Conveyance Policy.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "MRPL_CSR Policy_21.08.2024",
    fileName: "MRPL_CSR Policy_21.08.2024.pdf",
    filePath: "files/MRPL_CSR Policy_21.08.2024.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "MRPL_Equal Opportunity Policy",
    fileName: "MRPL_Equal Opportunity Policy.pdf",
    filePath: "files/MRPL_Equal Opportunity Policy.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "Referral Policy",
    fileName: "Referral Policy.pdf",
    filePath: "files/Referral Policy.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "Policy on Employment of Relatives in MRPL",
    fileName: "Policy on Employment of Relatives in MRPL.pdf",
    filePath: "files/Policy on Employment of Relatives in MRPL.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "Posh Policy-2025",
    fileName: "Posh Policy-2025.pdf",
    filePath: "files/Posh Policy-2025.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  {
    docName: "Rehire Policy",
    fileName: "Rehire Policy.pdf",
    filePath: "files/Rehire Policy.pdf",
    docAuthor: "System Generated",
    author: "",
    date: "",
  },
  // {
  //   docName: "Salary Advance Policy",
  //   fileName: "Salary Advance Policy.pdf",
  //   filePath: "files/Salary Advance Policy.pdf",
  //   docAuthor: "System Generated",
  //   author: "",
  //   date: "",
  // },
];
